import { styled, Box, Flex } from '@withjoy/joykit';

export const StyledBox = styled(Box)<{ hideBorder?: boolean | false }>`
  z-index: 4;
  ${props =>
    !props.hideBorder &&
    `
      border-bottom: 1px solid #f2f2f2;
    `}

  width: 100%;
`;

export const StyledFlex = styled(Flex)``;
